import React from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';

export function BottomDock(props) {
  const icon = 'nav-icon-default.png';
  const iconHover = 'nav-icon-hover.png';
  const links = [
    { url: '/about', title: 'ABOUT', icon: icon, iconHover: iconHover },
    { url: '/products', title: 'PRODUCTS', icon: icon, iconHover: iconHover },
    { url: '/shop', title: 'SHOP', icon: icon, iconHover: iconHover },
    { url: '/cart', title: 'CART', icon: icon, iconHover: iconHover },
    { url: '/support', title: 'SUPPORT', icon: icon, iconHover: iconHover }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index} ${isCurrent(link.url) ? 'selected' : ''}`}>
        <div className="icon">
          <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
          <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  );

  return (
    <>
      <div className="bottomMenuSpacer"></div>
      <nav className="bottomMenu">
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
      <div className="bottomMenuPadding"></div>
    </>
  );
}
